module.exports = __webpack_public_path__ + "img/ico-subject.7f175eab.svg";